export type WorkspacePlanType = 'FREE' | 'PREMIUM' | 'PRO' | 'TEAM';
export type PremiumEquivalentPlanType = 'free' | 'premium' | 'team';

// Pro remains premium-equivalent until product-specific feature gates are defined.
export const toPremiumEquivalentPlanType = (
  plan: WorkspacePlanType | null | undefined,
): PremiumEquivalentPlanType => {
  if (plan === 'TEAM') {
    return 'team';
  }

  if (plan === 'PREMIUM' || plan === 'PRO') {
    return 'premium';
  }

  return 'free';
};
